import React from 'react';
import classnames from 'classnames';
import toast from 'react-hot-toast';
import { track } from '$lib/tracking';
import ClipboardProvider from '$components/library/ClipboardProvider';
import styles from './styles.scss';

const ShareLink = ({ product }) => {
  const { slug: productSlug } = product;
  return (
    <ClipboardProvider>
      {({ copy }) => {
        const onClick = () => {
          const { href } = window.location;
          const shareUrl = `${href}#a_aid=share-topic`;
          copy(shareUrl);
          toast.success('Copied URL to share');
          track('Topic | Shared', { productSlug, href });
        };

        return (
          <a onClick={onClick}>
            Share {' '}
            <i className={classnames(styles.shareIcon, 'fad fa-share-square')} />
          </a>
        );
      }}
    </ClipboardProvider>
  );
};

export default ShareLink;
